module.exports = __webpack_public_path__ + "img/612.a8bb48d7.png";